import React from "react";
import Header from "@/components/landing/Header";
import ClosingInvitation from "@/components/landing/ClosingInvitation";
import ContactFooter from "@/components/landing/ContactFooter";
import PageFooter from "@/components/landing/PageFooter";

export default function Consultation() {
  return (
    <main className="bg-warm text-graphite min-h-screen">
      <Header />
      <div className="pt-24 md:pt-28" />
      <ClosingInvitation />
      <ContactFooter />
      <PageFooter />
    </main>
  );
}
